<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item title="공지사항 게시글 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="제목*">
                  <input class="input"
                         :value="notice.title"
                         @input="e => notice.title = e.target.value"
                         placeholder="제목을 입력하세요."
                         type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="공지대상">
                  <lp-adm-drop-input ref="adminput"
                                     :data.sync="service_list"
                                     :selectVal="notice.service_name"
                                     @onSelect="selectService"
                                     placeholder="검색 후 선택"
                                     width="160px"
                                     listAlign="center"
                                     style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

                  <!--<span class="select">
                    <select v-model="notice.target">
                      <option v-for="service in service_list"
                              :value="service.value">{{ service.label }}</option>
                    </select>
                  </span>-->
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용*">
                  <lp-editor :text.sync="notice.content"></lp-editor>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="이미지">
                  <draggable :options="{draggable:'.item'}">
                    <input-img style="display: inline-block;" :key="'img'+idx"
                               v-for="(img, idx) in notice.imgs"
                               class="item"
                               :idx="(idx+1)*1000"
                               @addImg="notice.imgs.push('')"
                               :url.sync="notice.imgs[idx]"></input-img>
                    <div class="lp-add-img" @click="notice.imgs.push('')">
                      <i class="material-icons">add</i>
                    </div>
                  </draggable>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>


      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";

  export default {
    components: {
      draggable,
      LpAdmDropInput,
      InputImg},
    layout: "Main",
    created() {
      this.$axios.get(this.getUrl('launchpack/service/simple')).then(res=>{
        this.service_list = res.data;
      });

      // 새로 등록
      if (this.$route.query.id === undefined) {
        /*this.notice.start_date = this.resetNewDate('start');
        this.notice.end_date = this.resetNewDate('end');
        this.notice.username = this.$store.getters.admin.username;*/
      }
      // 라우팅
      else {
        this.getData();
        this.notice.start_date = this.convertNewDate(this.notice.start_date);
        this.notice.end_date = this.convertNewDate(this.notice.end_date);
      }
    },
    data() {
      return {
        notice: {
          id: 0,
          start_date: '',
          end_date: '',
          // date: {
          //   min: "2017-01-01",
          //   max: "2099-12-31"
          // },
          priority: 99,
          title: "",
          content: "",
          imgs: [''],
          service_id: ""
        },
        service_list: []
      };
    },
    methods: {
      selectService(res) {
        this.notice.service_id = res.value;
      },
      getData() {
        this.$axios.get(this.getUrl('launchpack/notice/' + this.$route.query.id))
          .then(res => {
            this.notice = res.data;
          });
      },
      selDateMin(val) {
        this.notice.start_date = val;
      },
      selDateMax(val) {
        this.notice.end_date = val;
      },
      priorityKeyUp(value) {
        this.notice.priority = value;
      },
      done() {
        let err = '';
        if (!this.notice.title) err = '제목을 입력하세요.';
        else if (!this.notice.content) err = '내용을 입력하세요.';

        if (err) {
          this.toast(err);
          return;
        }

        let value = this.cloneItem(this.notice);
        if (!value.start_date) {
          value.start_date = '1111-01-01';
        }
        if (!value.end_date) {
          value.end_date = '9999-01-01';
        }

        if (!this.$route.query.id) {
          this.$axios.post(this.getUrl('launchpack/notice'), value).then(res => {
            if (res.status === 200) {
              this.toast('등록되었습니다.');
              this.$router.replace(this.getPath('launchpack/notice'));
            }
          })
        }
        else {
          this.$axios.patch(this.getUrl('launchpack/notice/' + this.$route.query.id), value).then(res => {
            if (res.status === 200) {
              this.toast('등록되었습니다.');
              this.$router.replace(this.getPath('launchpack/notice'));
            }
          })
        }
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .event-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }
</style>
